<template>
  <div class="container">
    <div
      ref="tabRef"
      class="tab"
      @mousedown="handleMouseDown"
      @mousemove="handleMouseMove"
      @mouseup="handleMouseUp"
      @mouseleave="handleMouseLeave"
    >
      <div
        v-for="(park, index) in parkListData"
        :key="park.id"
        class="tab-item"
        :class="{ active: activeIndex === index }"
        @click="selectPark(index)"
      >
        {{ park.tag || park.name }}
      </div>
    </div>
    <div v-if="currentPark" class="title">
      <span>{{ currentPark.name }}</span>
      <div class="address">
        <img src="@/img/agriculture/address_icon.png" alt="" />
        <span>{{ currentPark.address }}</span>
      </div>
    </div>
    <div v-if="currentPark" class="content">
      <!-- 园区信息 dataType=1 -->
      <div v-if="currentPark.dataType === 1" class="data-info">
        <div class="info-item">
          <div class="key">{{ currentPark.id == 3 ? '养殖' : '种植' }}面积</div>
          <div class="value">
            <span>{{ currentPark.totalArea || 0 }}</span>
            {{ currentPark.id == 3 ? '平' : '亩' }}
          </div>
        </div>
        <div class="info-item">
          <div class="key">2025年产量</div>
          <div class="value">
            <span>{{ currentPark.totalOutput2025 || 0 }}</span>
            {{ currentPark.id == 3 ? '对' : '斤' }}
          </div>
        </div>
        <div class="info-item">
          <div class="key">预计今年产量</div>
          <div class="value">
            <span>{{ currentPark.estimatedOutput || 0 }}</span>
            {{ currentPark.id == 3 ? '对' : '斤' }}
          </div>
        </div>
        <div class="info-item">
          <div class="key">预计今年销售额</div>
          <div class="value">
            <span>{{ currentPark.estimatedSales || 0 }}</span>
            元
          </div>
        </div>
      </div>
      <!-- 基地信息 dataType=2 -->
      <div v-else-if="currentPark.dataType === 2" class="data-info">
        <div class="info-item">
          <div class="key">仓库容量</div>
          <div class="value">
            <span>{{ currentPark.warehouseCapacity || 0 }}</span>
            立方米
          </div>
        </div>
        <div class="info-item">
          <div class="key">用工总人数</div>
          <div class="value">
            <span>{{ currentPark.employeeCount || 0 }}</span>
            人
          </div>
        </div>
        <div class="info-item">
          <div class="key">平均日配送单数</div>
          <div class="value">
            <span>{{ currentPark.avgDailyOrderCount || 0 }}</span>
            单
          </div>
        </div>
        <div class="info-item">
          <div class="key">平均日配送额</div>
          <div class="value">
            <span>{{ currentPark.avgDailyDeliveryAmount || 0 }}</span>
            万
          </div>
        </div>
      </div>
      <div v-if="currentPark" class="swiper">
        <div v-if="getFileList().length === 1" class="single-image">
          <div class="slide-card" @click="openModal(getFileList()[0])">
            <img
              v-if="getFileList()[0].type === 1"
              :src="getFileList()[0].url"
              :alt="getFileList()[0].name"
            />
            <video v-else-if="getFileList()[0].type === 2" :src="getFileList()[0].url" />
            <div v-else-if="getFileList()[0].type === 3" class="card-placeholder live">
              <img v-if="getFileList()[0].cover" :src="getFileList()[0].cover" class="live-cover" />
              <div class="live-badge">LIVE</div>
              <div class="live-icon">&#9654;</div>
            </div>
            <div v-else class="card-placeholder">{{ getFileList()[0].name || '视频流' }}</div>
          </div>
        </div>
        <div v-else-if="getFileList().length === 2" class="double-images">
          <div
            v-for="(file, index) in getFileList()"
            :key="index"
            class="slide-card"
            @click="openModal(file)"
          >
            <img v-if="file.type === 1" :src="file.url" :alt="file.name" />
            <video v-else-if="file.type === 2" :src="file.url" />
            <div v-else-if="file.type === 3" class="card-placeholder live">
              <img v-if="file.cover" :src="file.cover" class="live-cover" />
              <div class="live-badge">LIVE</div>
              <div class="live-icon">&#9654;</div>
            </div>
            <div v-else class="card-placeholder">{{ file.name || '视频流' }}</div>
          </div>
        </div>
        <swiper
          v-else-if="swiperKey"
          ref="parkSwiper"
          class="swiper-container"
          :options="getSwiperOption()"
          @click.native="onSwiperClick"
        >
          <swiper-slide v-for="(file, index) in getFileList()" :key="index">
            <div class="slide-card">
              <img v-if="file.type === 1" :src="file.url" :alt="file.name" />
              <video v-else-if="file.type === 2" :src="file.url" />
              <div v-else-if="file.type === 3" class="card-placeholder live">
                <img v-if="file.cover" :src="file.cover" class="live-cover" />
                <div class="live-badge">LIVE</div>
                <div class="live-icon">&#9654;</div>
              </div>
              <div v-else class="card-placeholder">{{ file.name || '视频流' }}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <!-- 弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title">{{ currentPark && currentPark.name }}</span>
          <span class="modal-close" @click="closeModal">×</span>
        </div>
        <div class="modal-body">
          <img
            v-if="modalFile && modalFile.type === 1"
            :src="modalFile.url"
            :alt="modalFile.name"
          />
          <video
            v-else-if="modalFile && modalFile.type === 2"
            :src="modalFile.url"
            controls
            autoplay
          />
          <div v-else class="modal-placeholder">
            {{ (modalFile && modalFile.name) || '视频流' }}
          </div>
        </div>
      </div>
    </div>
    <!-- 直播弹窗 -->
    <LiveVideoDialog ref="liveVideoDialog" />
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'swiper/dist/js/swiper.esm.bundle.js'
import { parkList } from '@/api/agriculture-dashboard'
import { ensureDashboardLogin } from '@/utils/dashboard-auth'
import LiveVideoDialog from '@/components/common/HikVideoTestDialog'
export default {
  components: {
    swiper,
    swiperSlide,
    LiveVideoDialog,
  },
  data() {
    return {
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      activeIndex: 0,
      parkListData: [],
      currentPark: null,
      swiperKey: false,
      showModal: false,
      modalFile: null,
    }
  },
  mounted() {
    this.fetchParkList()
    // 轮询获取数据
    this.pollingTimer = setInterval(() => {
      this.fetchParkList()
    }, process.env.VUE_APP_LTIME)
  },
  beforeDestroy() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
    }
  },
  methods: {
    async fetchParkList() {
      try {
        const res = await parkList({})
        this.parkListData = res.data || []
        if (this.parkListData.length > 0) {
          // 保持当前选中的 tab，不重置为第一个
          if (!this.currentPark || this.activeIndex >= this.parkListData.length) {
            this.activeIndex = 0
          }
          this.currentPark = this.parkListData[this.activeIndex]
        }
        if (!this.swiperKey) {
          this.$nextTick(() => {
            this.swiperKey = true
          })
        }
      } catch (e) {
        console.error('获取园区列表失败', e)
      }
    },
    selectPark(index) {
      this.activeIndex = index
      this.currentPark = this.parkListData[index]
      this.swiperKey = false
      this.$nextTick(() => {
        this.swiperKey = true
      })
    },
    getFileList() {
      return this.currentPark.fileList || []
    },
    getSwiperOption() {
      return {
        initialSlide: 0,
        slidesOffsetBefore: 0,
        spaceBetween: 0,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        centeredSlides: true,
        slideToClickedSlide: true,
        loop: true,
        autoplay: 3000,
        onSlideChangeEnd: swiper => {
          this.current = swiper.activeIndex
        },
      }
    },
    handleMouseDown(e) {
      this.isDragging = true
      this.startX = e.pageX - this.$refs.tabRef.offsetLeft
      this.scrollLeft = this.$refs.tabRef.scrollLeft
    },
    handleMouseMove(e) {
      if (!this.isDragging) return
      e.preventDefault()
      const x = e.pageX - this.$refs.tabRef.offsetLeft
      const walk = (x - this.startX) * 1.5
      this.$refs.tabRef.scrollLeft = this.scrollLeft - walk
    },
    handleMouseUp() {
      this.isDragging = false
    },
    handleMouseLeave() {
      this.isDragging = false
    },
    async openModal(file) {
      if (file.type === 3) {
        // 直播弹窗需要登录校验
        if (!(await ensureDashboardLogin())) return
        this.$refs.liveVideoDialog.show(file.url, file.name || '视频监控')
        return
      }
      this.modalFile = file
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.modalFile = null
      // 弹窗关闭后完全重新创建 Swiper
      if (this.getFileList().length > 2) {
        this.swiperKey = false
        this.$nextTick(() => {
          this.swiperKey = true
        })
      }
    },
    onSwiperClick() {
      const fileList = this.getFileList()
      if (fileList.length <= 2) return
      const swiper = this.$refs.parkSwiper.swiper
      const realIndex = swiper.realIndex
      if (fileList[realIndex]) {
        this.openModal(fileList[realIndex])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding-top: 54px;

  .tab {
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 24px;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    cursor: grab;
    user-select: none;

    &::-webkit-scrollbar {
      display: none;
    }

    &:active {
      cursor: grabbing;
    }

    .tab-item {
      flex-shrink: 0;
      cursor: pointesr;
      padding: 0 40px;
      min-width: 166px;
      height: 75px;
      font-weight: bold;
      font-size: 30px;
      color: #fefefe;
      line-height: 75px;
      text-align: center;
      margin-right: 15px;
      background: url('~@/img/agriculture/tab_bg.png');
      background-size: 100% 100%;

      &.active {
        // height: 75px;
        background: #0b48bf;
        // margin-top: 6px;
        // line-height: 75px;
      }
    }
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .address {
      display: flex;
      align-items: center;

      img {
        margin-right: 10px;
      }

      span {
        font-size: 18px;
      }
    }

    position: relative;
    width: 100%;
    height: 70px;
    border-radius: 7px 7px 0px 0px;
    font-weight: bold;
    font-size: 30px;
    color: #fefefe;
    line-height: 70px;
    padding-left: 41px;
    margin-bottom: 30px;

    span {
      position: relative;
      z-index: 9;
    }

    &::after {
      z-index: 8;
      content: '';
      position: absolute;
      left: 18px;
      bottom: 5px;
      width: 366px;
      height: 23px;
      background: url('~@/img/agriculture/title_line.png') 100% 100%;
    }
  }

  .content {
    display: flex;

    .data-info {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 506px;
      padding-left: 47px;

      .info-item {
        width: 50%;
        margin-bottom: 39px;

        .key {
          position: relative;
          font-weight: 500;
          font-size: 26px;
          color: #fefefe;
          line-height: 25px;
          margin-bottom: 16px;

          &::before {
            content: '';
            position: absolute;
            left: -38px;
            top: 3px;
            width: 20px;
            height: 20px;
            background: #0d6bcf;
          }
        }

        &:nth-child(2) {
          .key {
            &::before {
              background: #ff6c1d;
            }
          }
        }

        &:nth-child(3) {
          .key {
            &::before {
              background: #ffc300;
            }
          }
        }

        &:nth-child(4) {
          .key {
            &::before {
              background: #32d5b8;
            }
          }
        }

        .value {
          font-weight: 500;
          font-size: 21px;
          color: #ffffff;
          line-height: 26px;

          span {
            font-weight: 500;
            font-size: 34px;
            color: #66ffff;
          }
        }
      }
    }

    .swiper {
      .single-image {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        width: 640px;

        .slide-card {
          width: 334px;
          height: 196px;
          border-radius: 18px;
          overflow: hidden;
        }
      }

      .double-images {
        display: flex;
        justify-content: space-between;
        height: 200px;
        width: 640px;

        .slide-card {
          width: calc(50% - 10px);
          height: 196px;
          border-radius: 18px;
          overflow: hidden;
        }
      }

      .swiper-container {
        height: 200px;
        width: 640px;

        .swiper-slide {
          width: 334px !important;
          height: 196px;
          text-align: center;
          font-size: 18px;
          background: #fff;
          border-radius: 18px;
          overflow: hidden;

          /* Center slide text vertically */
          display: -webkit-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: center;
          -ms-pack: center;
          -webkit-justify-content: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;
          transition: 300ms;
          transform: scale(0.72);
        }

        .swiper-slide-active,
        .swiper-slide-duplicate-active {
          position: relative;
          z-index: 99;
          background-color: #fff;
          transform: scale(1);
        }

        // .swiper-slide-next {
        //   margin-left: -138px;
        // }

        // .swiper-slide-prev {
        //   margin-right: -138px;
        // }
        // .swiper-slide-duplicate-next {
        //   margin-left: 0;
        //   margin-right: -138px;
        // }

        // .swiper-slide-duplicate-prev  {
        //   // margin-right: 0;
        //   // margin-left: -138px;
        // }
      }

      .name {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 35px;
        background: rgba(1, 23, 54, 0.78);
        color: #fff;
        font-size: 16px;
        line-height: 35px;
        text-align: center;
      }

      .slide-card {
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .card-placeholder {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          color: #666;

          &.live {
            flex-direction: column;
            background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
            color: #e0e0e0;
            position: relative;

            .live-cover {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .live-badge {
              position: absolute;
              top: 8px;
              left: 8px;
              background: #ff3b3b;
              color: #fff;
              font-size: 10px;
              font-weight: bold;
              padding: 2px 6px;
              border-radius: 3px;
              z-index: 2;
              letter-spacing: 1px;
            }

            .live-icon {
              width: 40px;
              height: 40px;
              background: rgba(0, 0, 0, 0.5);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              font-size: 16px;
              line-height: 1;
              z-index: 2;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
    }
  }

  // 弹窗样式
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 20, 40, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;

    .modal-content {
      width: 2523px;
      height: 1641px;
      background: url('~@/img/agriculture/swiper_dialog_bg.png');
      background-size: 100% 100%;
      position: relative;
      display: flex;
      flex-direction: column;

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 40px 60px;
        height: 120px;

        .modal-title {
          font-size: 48px;
          font-weight: bold;
          color: #fff;
        }

        .modal-close {
          font-size: 60px;
          color: #fff;
          cursor: pointer;
          line-height: 1;

          &:hover {
            color: #00ffc8;
          }
        }
      }

      .modal-body {
        position: relative;
        flex: 1;
        padding: 40px 60px;
        display: flex;
        justify-content: center;
        align-items: center;

        img,
        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 16px;
        }

        .modal-placeholder {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          color: #fff;
          font-size: 32px;
        }

        .play-button {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 120px;
          height: 120px;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            background: #fff;
            transform: translate(-50%, -50%) scale(1.1);
          }

          .play-icon {
            width: 0;
            height: 0;
            border-left: 40px solid #0d5c5c;
            border-top: 26px solid transparent;
            border-bottom: 26px solid transparent;
            margin-left: 12px;
          }
        }
      }
    }
  }
}
</style>
